"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Modals/QueueMessages/PaceField.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _format = require('web/screens/Broadcast/format');
var _pace = require('web/screens/Broadcast/pace');

var _Form = require('web/components/Form');
var _SimpleSelect = require('web/components/Form/SimpleSelect'); var _SimpleSelect2 = _interopRequireDefault(_SimpleSelect);










/* Rev 33 T1: the send pace is a plain field in the Send now and Schedule
 * dialogs (no Advanced disclosure), saved with the send. Details no longer
 * shows it. */
const PaceField = ({ ms, onChange, count, rest = 0 }) => (
  _react2.default.createElement(_Form.InputSectionWrapper, { title: "Time between messages"  , className: "broadcast-pace--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
    , _react2.default.createElement(_SimpleSelect2.default, {
      value: String(ms),
      onChange: v => onChange(+v),
      options: _pace.paceOptions.call(void 0, ms), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
    )
    , _react2.default.createElement('span', { className: "broadcast--campaign-form--field-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      ,  _pace.paceHint.call(void 0, ms, count, 'message') 
      ,  rest > 0 && ` The other ${_format.formatCount.call(void 0, rest)} ${rest === 1 ? 'stays' : 'stay'} Not scheduled; send again to reach ${rest === 1 ? 'it' : 'them'}.` 
    )
  )
)

exports. default = PaceField
